import TransactionQuickLinksCard from '../../pages/Transactions/TransactionQuickLinksCard';
import React from 'react';

const TransactionQuickLinksCardContainer = ({ incomeModal, expenseModal, debtModal }) => {
	return (
		<TransactionQuickLinksCard
			expenseModal={expenseModal}
			incomeModal={incomeModal}
			debtModal={debtModal}
		/>
	);
};

export default TransactionQuickLinksCardContainer;
